import { partTypeWheel } from "../../../constants/partTypes";
import { OrderDetails } from "../../../stores/slices/cartSlice";

export const selectPackageInfo = (orderDetails?: OrderDetails): PackageInfo => {
  const partsCount = orderDetails?.orderItemList.length || 0;

  const wheelPart = orderDetails?.orderItemList.find(
    (item) => item.itemPart.partDetails.primaryPart.itemType === partTypeWheel
  );

  return {
    isValid: partsCount > 0,
    wheelPartId: wheelPart?.itemPart.partDetails.primaryPart.itemId ?? null,
  };
};

export type PackageInfo = {
  isValid: boolean;
  wheelPartId: null | string;
};
